import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'gf-progress-bar',
  template: require('./gf-progress-bar.component.html')
})
export class ProgressBarComponent implements OnInit {
  @Input() data: any;
  @Input() options: any;

  showBarColorGraduations: boolean;
  useLargeSize: boolean;
  showAmountsInLabel: boolean;
  labelOutside: boolean;

  ngOnInit() {
    this.showBarColorGraduations = _.get(this.options, 'useColorGraduation', false);
    this.useLargeSize = _.get(this.options, 'useLargeSize', false);
    this.showAmountsInLabel = _.get(this.options, 'showAmountsInLabel', false);
    this.labelOutside = _.get(this.options, 'labelOutside', false);
  }

  getPercentComplete(): number {
    return Math.round(_.get(this.data, 'percentComplete', 0));
  }

  getLabelText(): string {
    const percent = this.getPercentComplete();
    if (!this.showAmountsInLabel) return `${percent}%`;

    const amountComplete = _.get(this.data, 'amountComplete', 0);
    const amountTotal = _.get(this.data, 'amountTotal', 0);
    return `${percent}% (${amountComplete} / ${amountTotal})`;
  }

  getProgressBarClass(percentComplete: number): string {
    if (!this.showBarColorGraduations) return '';

    if (percentComplete > 80) {
      return 'progress-bar-success';
    }

    if (percentComplete > 50) {
      return 'progress-bar-warning';
    }

    return 'progress-bar-danger';
  }
}
